import dayjs from 'dayjs';
import {
  ACCESS_TIME_STATUS,
  type BookingSummary,
  type ShortReservation,
} from '@chekin/core';

function toMinutesSinceMidnight(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

export function isCurrentDateInRange(
  checkInDate: string | undefined,
  checkOutDate: string | undefined,
  today = new Date(),
): boolean {
  if (!checkInDate || !checkOutDate) return true;

  const todayStr = dayjs(today).format('YYYY-MM-DD');
  return todayStr >= checkInDate.slice(0, 10) && todayStr <= checkOutDate.slice(0, 10);
}

export function isCurrentTimeInAccessWindow(
  startTime: string | undefined,
  endTime: string | undefined,
  now = new Date(),
): boolean {
  console.log('******METODO isCurrentTimeInAccessWindow *******');
  console.log('Tu fecha del browser es:', now);
  console.log('Tu startTime es:', startTime);
  console.log('Tu endTime es:', endTime);
  console.log('******METODO isCurrentTimeInAccessWindow *******');
  if (!startTime || !endTime) return true;

  const d = dayjs(now);
  const nowMinutes = d.hour() * 60 + d.minute();
  const startMinutes = toMinutesSinceMidnight(startTime);
  const endMinutes = toMinutesSinceMidnight(endTime);

  if (startMinutes <= endMinutes) {
    return nowMinutes >= startMinutes && nowMinutes <= endMinutes;
  }

  return nowMinutes >= startMinutes || nowMinutes <= endMinutes;
}

export function getAccessWindow(
  summary: BookingSummary | undefined,
  reservation: ShortReservation | undefined,
): {
  startTime: string | undefined;
  endTime: string | undefined;
  checkInDate: string | undefined;
  checkOutDate: string | undefined;
} {
  if (summary?.access_time_status === ACCESS_TIME_STATUS.custom) {
    console.log('******METODO getAccessWindow -- SUMMARY IF BLOCK *******');
    console.log('Tu summary?.access_start_time:', summary?.access_start_time);
    console.log('Tu summary?.access_end_time:', summary?.access_end_time);
    console.log('Tu summary?.check_in_date:', summary?.check_in_date);
    console.log('Tu summary?.check_out_date:', summary?.check_out_date);
    console.log('******METODO getAccessWindow -- SUMMARY IF BLOCK *******');

    return {
      startTime: summary.access_start_time,
      endTime: summary.access_end_time,
      checkInDate: summary.check_in_date,
      checkOutDate: summary.check_out_date,
    };
  }
  console.log('******METODO getAccessWindow -- RESERVATION IF BLOCK *******');
  console.log('Tu reservation?.access_start_time:', reservation?.access_start_time);
  console.log('Tu reservation?.access_end_time:', reservation?.access_end_time);
  console.log('Tu reservation?.check_in_date:', reservation?.check_in_date);
  console.log('Tu reservation?.check_out_date:', reservation?.check_out_date);
  console.log('******METODO getAccessWindow -- RESERVATION IF BLOCK *******');
  return {
    startTime: reservation?.access_start_time,
    endTime: reservation?.access_end_time,
    checkInDate: reservation?.check_in_date,
    checkOutDate: reservation?.check_out_date,
  };
}
